import React from 'react'
import UnderConstruction from '../components/UnderConstruction'

const Areas = () => {
  return <UnderConstruction pageName="Áreas" />
}

export default Areas